"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapper = void 0;
/* tslint:disable */
var wrapper;
(function (wrapper) {
    var wix;
    (function (wix) {
        var feed;
        (function (feed) {
            var FeedItemPermission;
            (function (FeedItemPermission) {
                FeedItemPermission["CREATE"] = "CREATE";
                FeedItemPermission["EDIT"] = "EDIT";
                FeedItemPermission["DELETE"] = "DELETE";
                FeedItemPermission["REACT"] = "REACT";
                FeedItemPermission["REPORT"] = "REPORT";
                FeedItemPermission["ADD_COMMENT"] = "ADD_COMMENT";
                FeedItemPermission["PIN"] = "PIN";
                FeedItemPermission["ADD_TOPIC"] = "ADD_TOPIC";
                FeedItemPermission["ASSIGN_TOPIC"] = "ASSIGN_TOPIC";
            })(FeedItemPermission = feed.FeedItemPermission || (feed.FeedItemPermission = {}));
            var component;
            (function (component) {
                var FeedComponentService = /** @class */ (function () {
                    function FeedComponentService() {
                    }
                    return FeedComponentService;
                }());
                component.FeedComponentService = FeedComponentService;
                var Role;
                (function (Role) {
                    Role["VIEWER"] = "VIEWER";
                    Role["WRITER"] = "WRITER";
                    Role["ADMIN"] = "ADMIN";
                })(Role = component.Role || (component.Role = {}));
            })(component = feed.component || (feed.component = {}));
            var ContentPreviewService = /** @class */ (function () {
                function ContentPreviewService() {
                }
                return ContentPreviewService;
            }());
            feed.ContentPreviewService = ContentPreviewService;
            var FeedMigrationService = /** @class */ (function () {
                function FeedMigrationService() {
                }
                return FeedMigrationService;
            }());
            feed.FeedMigrationService = FeedMigrationService;
            var FeedService = /** @class */ (function () {
                function FeedService() {
                }
                return FeedService;
            }());
            feed.FeedService = FeedService;
            var PinPolicy;
            (function (PinPolicy) {
                var OnExceedAllowedPins;
                (function (OnExceedAllowedPins) {
                    OnExceedAllowedPins["RESPOND_WITH_ALREADY_EXISTS"] = "RESPOND_WITH_ALREADY_EXISTS";
                    OnExceedAllowedPins["REPLACE_OLDEST"] = "REPLACE_OLDEST";
                })(OnExceedAllowedPins = PinPolicy.OnExceedAllowedPins || (PinPolicy.OnExceedAllowedPins = {}));
            })(PinPolicy = feed.PinPolicy || (feed.PinPolicy = {}));
            var FeedItemSource;
            (function (FeedItemSource) {
                FeedItemSource["CREATIONS"] = "CREATIONS";
                FeedItemSource["UPDATES"] = "UPDATES";
                FeedItemSource["PINNED"] = "PINNED";
                FeedItemSource["UNPINNED"] = "UNPINNED";
                FeedItemSource["DELETED"] = "DELETED";
                FeedItemSource["UPDATES_SINCE"] = "UPDATES_SINCE";
            })(FeedItemSource = feed.FeedItemSource || (feed.FeedItemSource = {}));
        })(feed = wix.feed || (wix.feed = {}));
        var comments;
        (function (comments) {
            var Ordering;
            (function (Ordering) {
                Ordering["OLDEST_FIRST"] = "OLDEST_FIRST";
                Ordering["LATEST_FIRST"] = "LATEST_FIRST";
            })(Ordering = comments.Ordering || (comments.Ordering = {}));
            var UserAction;
            (function (UserAction) {
                UserAction["VIEW"] = "VIEW";
                UserAction["ADD_COMMENT"] = "ADD_COMMENT";
                UserAction["REACT"] = "REACT";
                UserAction["UNREACT"] = "UNREACT";
                UserAction["REPORT"] = "REPORT";
                UserAction["EDIT"] = "EDIT";
                UserAction["DELETE"] = "DELETE";
                UserAction["VIEW_REPORT"] = "VIEW_REPORT";
            })(UserAction = comments.UserAction || (comments.UserAction = {}));
            var ReportType;
            (function (ReportType) {
                ReportType["UNWANTED_CONTENT"] = "UNWANTED_CONTENT";
                ReportType["HARASSMENT"] = "HARASSMENT";
                ReportType["INAPPROPRIATE_CONTENT"] = "INAPPROPRIATE_CONTENT";
                ReportType["HATE_SPEECH_OR_GRAPHIC"] = "HATE_SPEECH_OR_GRAPHIC";
                ReportType["OTHER"] = "OTHER";
                ReportType["UnwantedContent"] = "UnwantedContent";
                ReportType["Harrasment"] = "Harrasment";
                ReportType["InappropiateContent"] = "InappropiateContent";
                ReportType["HateSpeechOrGraphic"] = "HateSpeechOrGraphic";
            })(ReportType = comments.ReportType || (comments.ReportType = {}));
            var v0;
            (function (v0) {
                var UserAction;
                (function (UserAction) {
                    UserAction["VIEW"] = "VIEW";
                    UserAction["ADD_COMMENT"] = "ADD_COMMENT";
                    UserAction["REACT"] = "REACT";
                    UserAction["UNREACT"] = "UNREACT";
                    UserAction["REPORT"] = "REPORT";
                    UserAction["EDIT"] = "EDIT";
                    UserAction["DELETE"] = "DELETE";
                    UserAction["VIEW_REPORT"] = "VIEW_REPORT";
                })(UserAction = v0.UserAction || (v0.UserAction = {}));
            })(v0 = comments.v0 || (comments.v0 = {}));
            var component;
            (function (component) {
                var CommentsHostedSpi = /** @class */ (function () {
                    function CommentsHostedSpi() {
                    }
                    return CommentsHostedSpi;
                }());
                component.CommentsHostedSpi = CommentsHostedSpi;
                var CommentsComponentService = /** @class */ (function () {
                    function CommentsComponentService() {
                    }
                    return CommentsComponentService;
                }());
                component.CommentsComponentService = CommentsComponentService;
                var Permission;
                (function (Permission) {
                    Permission["VIEWER"] = "VIEWER";
                    Permission["WRITER"] = "WRITER";
                    Permission["ADMIN"] = "ADMIN";
                })(Permission = component.Permission || (component.Permission = {}));
                var Feature;
                (function (Feature) {
                    Feature["ALL"] = "ALL";
                    Feature["REPLIES"] = "REPLIES";
                    Feature["REACTIONS"] = "REACTIONS";
                })(Feature = component.Feature || (component.Feature = {}));
            })(component = comments.component || (comments.component = {}));
            var CommentsSeoService = /** @class */ (function () {
                function CommentsSeoService() {
                }
                return CommentsSeoService;
            }());
            comments.CommentsSeoService = CommentsSeoService;
            var CommentsService = /** @class */ (function () {
                function CommentsService() {
                }
                return CommentsService;
            }());
            comments.CommentsService = CommentsService;
            var gdpr;
            (function (gdpr) {
                var GdprService = /** @class */ (function () {
                    function GdprService() {
                    }
                    return GdprService;
                }());
                gdpr.GdprService = GdprService;
                var GdprComment;
                (function (GdprComment) {
                    var Status;
                    (function (Status) {
                        Status["CREATED"] = "CREATED";
                        Status["REMOVED"] = "REMOVED";
                    })(Status = GdprComment.Status || (GdprComment.Status = {}));
                })(GdprComment = gdpr.GdprComment || (gdpr.GdprComment = {}));
            })(gdpr = comments.gdpr || (comments.gdpr = {}));
            var FeedPageCursor;
            (function (FeedPageCursor) {
                var PriorityTag;
                (function (PriorityTag) {
                    PriorityTag["REMAINING"] = "REMAINING";
                    PriorityTag["PINNED"] = "PINNED";
                })(PriorityTag = FeedPageCursor.PriorityTag || (FeedPageCursor.PriorityTag = {}));
            })(FeedPageCursor = comments.FeedPageCursor || (comments.FeedPageCursor = {}));
        })(comments = wix.comments || (wix.comments = {}));
        var api;
        (function (api) {
            var Format;
            (function (Format) {
                Format["EMAIL"] = "EMAIL";
                Format["HOSTNAME"] = "HOSTNAME";
                Format["IPV4"] = "IPV4";
                Format["IPV6"] = "IPV6";
                Format["URI"] = "URI";
                Format["WEB_URL"] = "WEB_URL";
                Format["PHONE"] = "PHONE";
                Format["CREDIT_CARD"] = "CREDIT_CARD";
                Format["GUID"] = "GUID";
                Format["COUNTRY"] = "COUNTRY";
                Format["LANGUAGE"] = "LANGUAGE";
                Format["DECIMAL_VALUE"] = "DECIMAL_VALUE";
                Format["CURRENCY"] = "CURRENCY";
                Format["LANGUAGE_TAG"] = "LANGUAGE_TAG";
                Format["COLOR_HEX"] = "COLOR_HEX";
                Format["LOCAL_DATE"] = "LOCAL_DATE";
                Format["LOCAL_TIME"] = "LOCAL_TIME";
                Format["LOCAL_DATE_TIME"] = "LOCAL_DATE_TIME";
            })(Format = api.Format || (api.Format = {}));
            var Crud;
            (function (Crud) {
                var Method;
                (function (Method) {
                    Method["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
                    Method["CREATE"] = "CREATE";
                    Method["GET_ITEM"] = "GET_ITEM";
                    Method["UPDATE"] = "UPDATE";
                    Method["DELETE"] = "DELETE";
                    Method["UPSERT"] = "UPSERT";
                    Method["LIST"] = "LIST";
                    Method["QUERY"] = "QUERY";
                    Method["BULK_CREATE"] = "BULK_CREATE";
                    Method["BULK_UPDATE"] = "BULK_UPDATE";
                    Method["BULK_UPDATE_BY_FILTER"] = "BULK_UPDATE_BY_FILTER";
                    Method["BULK_DELETE"] = "BULK_DELETE";
                    Method["BULK_DELETE_BY_FILTER"] = "BULK_DELETE_BY_FILTER";
                    Method["BULK_UPSERT"] = "BULK_UPSERT";
                })(Method = Crud.Method || (Crud.Method = {}));
            })(Crud = api.Crud || (api.Crud = {}));
            var Paging;
            (function (Paging) {
                var Type;
                (function (Type) {
                    Type["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
                    Type["OFFSET"] = "OFFSET";
                    Type["CURSOR"] = "CURSOR";
                })(Type = Paging.Type || (Paging.Type = {}));
            })(Paging = api.Paging || (api.Paging = {}));
            var Translatable;
            (function (Translatable) {
                var Type;
                (function (Type) {
                    Type["UNDEFINED_TYPE"] = "UNDEFINED_TYPE";
                    Type["SHORT_TEXT"] = "SHORT_TEXT";
                    Type["LONG_TEXT"] = "LONG_TEXT";
                    Type["RICH_TEXT"] = "RICH_TEXT";
                    Type["RICH_CONTENT_EDITOR"] = "RICH_CONTENT_EDITOR";
                    Type["SELECTION"] = "SELECTION";
                    Type["MULTI_SELECTION"] = "MULTI_SELECTION";
                    Type["DOCUMENT"] = "DOCUMENT";
                    Type["IMAGE"] = "IMAGE";
                    Type["VIDEO"] = "VIDEO";
                })(Type = Translatable.Type || (Translatable.Type = {}));
            })(Translatable = api.Translatable || (api.Translatable = {}));
            var ServiceAppendix;
            (function (ServiceAppendix) {
                var Type;
                (function (Type) {
                    Type["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
                    Type["NILE"] = "NILE";
                    Type["MESSAGE_BUS"] = "MESSAGE_BUS";
                })(Type = ServiceAppendix.Type || (ServiceAppendix.Type = {}));
            })(ServiceAppendix = api.ServiceAppendix || (api.ServiceAppendix = {}));
            var Exposure;
            (function (Exposure) {
                Exposure["PRIVATE"] = "PRIVATE";
                Exposure["INTERNAL"] = "INTERNAL";
                Exposure["PUBLIC"] = "PUBLIC";
            })(Exposure = api.Exposure || (api.Exposure = {}));
            var Maturity;
            (function (Maturity) {
                Maturity["ALPHA"] = "ALPHA";
                Maturity["BETA"] = "BETA";
                Maturity["IA"] = "IA";
                Maturity["GA"] = "GA";
                Maturity["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
            })(Maturity = api.Maturity || (api.Maturity = {}));
            var Callback;
            (function (Callback) {
                var EventType;
                (function (EventType) {
                    EventType["UNKNOWN"] = "UNKNOWN";
                    EventType["CREATED"] = "CREATED";
                    EventType["UPDATED"] = "UPDATED";
                    EventType["DELETED"] = "DELETED";
                    EventType["ACTION"] = "ACTION";
                })(EventType = Callback.EventType || (Callback.EventType = {}));
            })(Callback = api.Callback || (api.Callback = {}));
            var MessageAppendix;
            (function (MessageAppendix) {
                var Type;
                (function (Type) {
                    Type["UNKNOWN_APPENDIX_TYPE"] = "UNKNOWN_APPENDIX_TYPE";
                    Type["AUTO_VELO"] = "AUTO_VELO";
                    Type["DOCS_CONF"] = "DOCS_CONF";
                    Type["MULTILINGUAL"] = "MULTILINGUAL";
                })(Type = MessageAppendix.Type || (MessageAppendix.Type = {}));
            })(MessageAppendix = api.MessageAppendix || (api.MessageAppendix = {}));
            var ValidationError;
            (function (ValidationError) {
                var RuleType;
                (function (RuleType) {
                    RuleType["VALIDATION"] = "VALIDATION";
                    RuleType["OTHER"] = "OTHER";
                    RuleType["MAX"] = "MAX";
                    RuleType["MIN"] = "MIN";
                    RuleType["MAX_LENGTH"] = "MAX_LENGTH";
                    RuleType["MIN_LENGTH"] = "MIN_LENGTH";
                    RuleType["MAX_SIZE"] = "MAX_SIZE";
                    RuleType["MIN_SIZE"] = "MIN_SIZE";
                    RuleType["FORMAT"] = "FORMAT";
                    RuleType["DECIMAL_LTE"] = "DECIMAL_LTE";
                    RuleType["DECIMAL_GTE"] = "DECIMAL_GTE";
                    RuleType["DECIMAL_LT"] = "DECIMAL_LT";
                    RuleType["DECIMAL_GT"] = "DECIMAL_GT";
                    RuleType["DECIMAL_MAX_SCALE"] = "DECIMAL_MAX_SCALE";
                    RuleType["INVALID_ENUM_VALUE"] = "INVALID_ENUM_VALUE";
                    RuleType["REQUIRED_FIELD"] = "REQUIRED_FIELD";
                })(RuleType = ValidationError.RuleType || (ValidationError.RuleType = {}));
            })(ValidationError = api.ValidationError || (api.ValidationError = {}));
            var PermissionType;
            (function (PermissionType) {
                PermissionType["AUTO"] = "AUTO";
                PermissionType["MANUAL"] = "MANUAL";
            })(PermissionType = api.PermissionType || (api.PermissionType = {}));
        })(api = wix.api || (wix.api = {}));
        var common;
        (function (common) {
            var Subdivision;
            (function (Subdivision) {
                var SubdivisionType;
                (function (SubdivisionType) {
                    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
                    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
                    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
                    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
                    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
                    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
                    SubdivisionType["COUNTRY"] = "COUNTRY";
                })(SubdivisionType = Subdivision.SubdivisionType || (Subdivision.SubdivisionType = {}));
            })(Subdivision = common.Subdivision || (common.Subdivision = {}));
            var VatType;
            (function (VatType) {
                VatType["UNSPECIFIED"] = "UNSPECIFIED";
                VatType["CPF"] = "CPF";
                VatType["CNPJ"] = "CNPJ";
            })(VatType = common.VatType || (common.VatType = {}));
            var BulkActionType;
            (function (BulkActionType) {
                BulkActionType["UNKNOWN_ACTION_TYPE"] = "UNKNOWN_ACTION_TYPE";
                BulkActionType["INSERT"] = "INSERT";
                BulkActionType["UPDATE"] = "UPDATE";
                BulkActionType["DELETE"] = "DELETE";
            })(BulkActionType = common.BulkActionType || (common.BulkActionType = {}));
            var SortOrder;
            (function (SortOrder) {
                SortOrder["ASC"] = "ASC";
                SortOrder["DESC"] = "DESC";
            })(SortOrder = common.SortOrder || (common.SortOrder = {}));
        })(common = wix.common || (wix.common = {}));
        var social;
        (function (social) {
            var ContentType;
            (function (ContentType) {
                ContentType["PLAIN_TEXT"] = "PLAIN_TEXT";
                ContentType["DRAFTJS"] = "DRAFTJS";
            })(ContentType = social.ContentType || (social.ContentType = {}));
            var MediaType;
            (function (MediaType) {
                MediaType["ATTACHMENT"] = "ATTACHMENT";
                MediaType["IMAGE"] = "IMAGE";
                MediaType["VIDEO"] = "VIDEO";
            })(MediaType = social.MediaType || (social.MediaType = {}));
            var IdentityType;
            (function (IdentityType) {
                IdentityType["ANONYMOUS"] = "ANONYMOUS";
                IdentityType["MEMBER"] = "MEMBER";
                IdentityType["USER"] = "USER";
                IdentityType["EXTERNAL_APP"] = "EXTERNAL_APP";
            })(IdentityType = social.IdentityType || (social.IdentityType = {}));
            var ActivitiesService = /** @class */ (function () {
                function ActivitiesService() {
                }
                return ActivitiesService;
            }());
            social.ActivitiesService = ActivitiesService;
            var ContentContainersService = /** @class */ (function () {
                function ContentContainersService() {
                }
                return ContentContainersService;
            }());
            social.ContentContainersService = ContentContainersService;
            var DbManagementService = /** @class */ (function () {
                function DbManagementService() {
                }
                return DbManagementService;
            }());
            social.DbManagementService = DbManagementService;
            var EventOrdering;
            (function (EventOrdering) {
                EventOrdering["LATEST"] = "LATEST";
                EventOrdering["OLDEST"] = "OLDEST";
            })(EventOrdering = social.EventOrdering || (social.EventOrdering = {}));
            var ProfilesService = /** @class */ (function () {
                function ProfilesService() {
                }
                return ProfilesService;
            }());
            social.ProfilesService = ProfilesService;
            var groups;
            (function (groups) {
                var api;
                (function (api) {
                    var v1;
                    (function (v1) {
                        var SocialGroupsActivityService = /** @class */ (function () {
                            function SocialGroupsActivityService() {
                            }
                            return SocialGroupsActivityService;
                        }());
                        v1.SocialGroupsActivityService = SocialGroupsActivityService;
                        var SocialGroupsAppsService = /** @class */ (function () {
                            function SocialGroupsAppsService() {
                            }
                            return SocialGroupsAppsService;
                        }());
                        v1.SocialGroupsAppsService = SocialGroupsAppsService;
                        var GroupPrivacyLevel;
                        (function (GroupPrivacyLevel) {
                            GroupPrivacyLevel["SECRET"] = "SECRET";
                            GroupPrivacyLevel["PRIVATE"] = "PRIVATE";
                            GroupPrivacyLevel["PUBLIC"] = "PUBLIC";
                        })(GroupPrivacyLevel = v1.GroupPrivacyLevel || (v1.GroupPrivacyLevel = {}));
                        var RelationshipWithGroup;
                        (function (RelationshipWithGroup) {
                            RelationshipWithGroup["NONE"] = "NONE";
                            RelationshipWithGroup["JOINED"] = "JOINED";
                            RelationshipWithGroup["PENDING_APPROVAL"] = "PENDING_APPROVAL";
                            RelationshipWithGroup["REJECTED_MEMBERSHIP"] = "REJECTED_MEMBERSHIP";
                        })(RelationshipWithGroup = v1.RelationshipWithGroup || (v1.RelationshipWithGroup = {}));
                        var RoleInGroup;
                        (function (RoleInGroup) {
                            RoleInGroup["GROUP_ADMIN"] = "GROUP_ADMIN";
                            RoleInGroup["GROUP_MEMBER"] = "GROUP_MEMBER";
                            RoleInGroup["SITE_ADMIN"] = "SITE_ADMIN";
                        })(RoleInGroup = v1.RoleInGroup || (v1.RoleInGroup = {}));
                        var GroupAppKey;
                        (function (GroupAppKey) {
                            GroupAppKey["MEMBERS_APP"] = "MEMBERS_APP";
                            GroupAppKey["FEED_APP"] = "FEED_APP";
                            GroupAppKey["ABOUT_APP"] = "ABOUT_APP";
                            GroupAppKey["GALLERY_APP"] = "GALLERY_APP";
                            GroupAppKey["EVENTS_APP"] = "EVENTS_APP";
                            GroupAppKey["CUSTOM_APP"] = "CUSTOM_APP";
                        })(GroupAppKey = v1.GroupAppKey || (v1.GroupAppKey = {}));
                        var GroupsSortBy;
                        (function (GroupsSortBy) {
                            GroupsSortBy["RECENT_ACTIVITY"] = "RECENT_ACTIVITY";
                            GroupsSortBy["NAME"] = "NAME";
                            GroupsSortBy["MEMBERS_COUNT"] = "MEMBERS_COUNT";
                        })(GroupsSortBy = v1.GroupsSortBy || (v1.GroupsSortBy = {}));
                        var CreateGroupsPolicy;
                        (function (CreateGroupsPolicy) {
                            CreateGroupsPolicy["ONLY_ME"] = "ONLY_ME";
                            CreateGroupsPolicy["MEMBERS"] = "MEMBERS";
                            CreateGroupsPolicy["MEMBERS_WITH_MY_APPROVAL"] = "MEMBERS_WITH_MY_APPROVAL";
                        })(CreateGroupsPolicy = v1.CreateGroupsPolicy || (v1.CreateGroupsPolicy = {}));
                        var GroupApprovalStatus;
                        (function (GroupApprovalStatus) {
                            GroupApprovalStatus["EMPTY"] = "EMPTY";
                            GroupApprovalStatus["PENDING"] = "PENDING";
                            GroupApprovalStatus["APPROVED"] = "APPROVED";
                            GroupApprovalStatus["REJECTED"] = "REJECTED";
                            GroupApprovalStatus["CANCELLED"] = "CANCELLED";
                        })(GroupApprovalStatus = v1.GroupApprovalStatus || (v1.GroupApprovalStatus = {}));
                        var GroupAccessRestriction;
                        (function (GroupAccessRestriction) {
                            var Type;
                            (function (Type) {
                                Type["ADMIN_APPROVAL"] = "ADMIN_APPROVAL";
                                Type["PAID_PLANS"] = "PAID_PLANS";
                                Type["EVENTS"] = "EVENTS";
                            })(Type = GroupAccessRestriction.Type || (GroupAccessRestriction.Type = {}));
                        })(GroupAccessRestriction = v1.GroupAccessRestriction || (v1.GroupAccessRestriction = {}));
                        var ItemsToUpdate;
                        (function (ItemsToUpdate) {
                            ItemsToUpdate["BY_ID"] = "BY_ID";
                            ItemsToUpdate["ALL_ITEMS"] = "ALL_ITEMS";
                        })(ItemsToUpdate = v1.ItemsToUpdate || (v1.ItemsToUpdate = {}));
                        var SocialGroupsEventsMappingService = /** @class */ (function () {
                            function SocialGroupsEventsMappingService() {
                            }
                            return SocialGroupsEventsMappingService;
                        }());
                        v1.SocialGroupsEventsMappingService = SocialGroupsEventsMappingService;
                        var SocialGroupsMediaIntegrationService = /** @class */ (function () {
                            function SocialGroupsMediaIntegrationService() {
                            }
                            return SocialGroupsMediaIntegrationService;
                        }());
                        v1.SocialGroupsMediaIntegrationService = SocialGroupsMediaIntegrationService;
                        var SocialGroupsFeedIntegrationService = /** @class */ (function () {
                            function SocialGroupsFeedIntegrationService() {
                            }
                            return SocialGroupsFeedIntegrationService;
                        }());
                        v1.SocialGroupsFeedIntegrationService = SocialGroupsFeedIntegrationService;
                        var SocialGroupsPageRoutingService = /** @class */ (function () {
                            function SocialGroupsPageRoutingService() {
                            }
                            return SocialGroupsPageRoutingService;
                        }());
                        v1.SocialGroupsPageRoutingService = SocialGroupsPageRoutingService;
                        var TriggerRemindersToCreateGroupRequestMode;
                        (function (TriggerRemindersToCreateGroupRequestMode) {
                            TriggerRemindersToCreateGroupRequestMode["TEST_MODE"] = "TEST_MODE";
                            TriggerRemindersToCreateGroupRequestMode["PROD_MODE"] = "PROD_MODE";
                        })(TriggerRemindersToCreateGroupRequestMode = v1.TriggerRemindersToCreateGroupRequestMode || (v1.TriggerRemindersToCreateGroupRequestMode = {}));
                        var SocialGroupsNotificationTriggerService = /** @class */ (function () {
                            function SocialGroupsNotificationTriggerService() {
                            }
                            return SocialGroupsNotificationTriggerService;
                        }());
                        v1.SocialGroupsNotificationTriggerService = SocialGroupsNotificationTriggerService;
                        var SocialGroupsGdprService = /** @class */ (function () {
                            function SocialGroupsGdprService() {
                            }
                            return SocialGroupsGdprService;
                        }());
                        v1.SocialGroupsGdprService = SocialGroupsGdprService;
                        var SocialGroupsInternalService = /** @class */ (function () {
                            function SocialGroupsInternalService() {
                            }
                            return SocialGroupsInternalService;
                        }());
                        v1.SocialGroupsInternalService = SocialGroupsInternalService;
                        var SocialGroupsService = /** @class */ (function () {
                            function SocialGroupsService() {
                            }
                            return SocialGroupsService;
                        }());
                        v1.SocialGroupsService = SocialGroupsService;
                        var SocialGroupsInviteService = /** @class */ (function () {
                            function SocialGroupsInviteService() {
                            }
                            return SocialGroupsInviteService;
                        }());
                        v1.SocialGroupsInviteService = SocialGroupsInviteService;
                        var ListMembershipQuestionAnswersRequest;
                        (function (ListMembershipQuestionAnswersRequest) {
                            var ItemsFilter;
                            (function (ItemsFilter) {
                                ItemsFilter["BY_ID"] = "BY_ID";
                                ItemsFilter["ALL_ITEMS"] = "ALL_ITEMS";
                            })(ItemsFilter = ListMembershipQuestionAnswersRequest.ItemsFilter || (ListMembershipQuestionAnswersRequest.ItemsFilter = {}));
                        })(ListMembershipQuestionAnswersRequest = v1.ListMembershipQuestionAnswersRequest || (v1.ListMembershipQuestionAnswersRequest = {}));
                        var SocialGroupsMembershipService = /** @class */ (function () {
                            function SocialGroupsMembershipService() {
                            }
                            return SocialGroupsMembershipService;
                        }());
                        v1.SocialGroupsMembershipService = SocialGroupsMembershipService;
                        var MigrationType;
                        (function (MigrationType) {
                            MigrationType["TEST"] = "TEST";
                            MigrationType["DEFAULT_SORT_BY_MIGRATION"] = "DEFAULT_SORT_BY_MIGRATION";
                            MigrationType["SET_PROFILE_PRIVACY"] = "SET_PROFILE_PRIVACY";
                            MigrationType["CLEAR_PRIVATE_MEMBER_FLAG"] = "CLEAR_PRIVATE_MEMBER_FLAG";
                            MigrationType["ADD_EVENTS_TAB"] = "ADD_EVENTS_TAB";
                        })(MigrationType = v1.MigrationType || (v1.MigrationType = {}));
                        var SocialGroupsMigrationService = /** @class */ (function () {
                            function SocialGroupsMigrationService() {
                            }
                            return SocialGroupsMigrationService;
                        }());
                        v1.SocialGroupsMigrationService = SocialGroupsMigrationService;
                        var NotificationChannel;
                        (function (NotificationChannel) {
                            NotificationChannel["WEB"] = "WEB";
                            NotificationChannel["MOBILE"] = "MOBILE";
                            NotificationChannel["EMAIL"] = "EMAIL";
                        })(NotificationChannel = v1.NotificationChannel || (v1.NotificationChannel = {}));
                        var NotificationType;
                        (function (NotificationType) {
                            NotificationType["ALL"] = "ALL";
                            NotificationType["POST"] = "POST";
                            NotificationType["COMMENT"] = "COMMENT";
                            NotificationType["REACTION"] = "REACTION";
                            NotificationType["MEMBERSHIP"] = "MEMBERSHIP";
                            NotificationType["MEMBERS_JOIN"] = "MEMBERS_JOIN";
                            NotificationType["GROUP_UPDATES"] = "GROUP_UPDATES";
                            NotificationType["WEEKLY_DIGEST"] = "WEEKLY_DIGEST";
                        })(NotificationType = v1.NotificationType || (v1.NotificationType = {}));
                        var SocialGroupsNotificationSettingsService = /** @class */ (function () {
                            function SocialGroupsNotificationSettingsService() {
                            }
                            return SocialGroupsNotificationSettingsService;
                        }());
                        v1.SocialGroupsNotificationSettingsService = SocialGroupsNotificationSettingsService;
                        var SocialGroupsRolesService = /** @class */ (function () {
                            function SocialGroupsRolesService() {
                            }
                            return SocialGroupsRolesService;
                        }());
                        v1.SocialGroupsRolesService = SocialGroupsRolesService;
                        var SocialGroupsRulesService = /** @class */ (function () {
                            function SocialGroupsRulesService() {
                            }
                            return SocialGroupsRulesService;
                        }());
                        v1.SocialGroupsRulesService = SocialGroupsRulesService;
                        var SocialGroupsTasksService = /** @class */ (function () {
                            function SocialGroupsTasksService() {
                            }
                            return SocialGroupsTasksService;
                        }());
                        v1.SocialGroupsTasksService = SocialGroupsTasksService;
                    })(v1 = api.v1 || (api.v1 = {}));
                })(api = groups.api || (groups.api = {}));
            })(groups = social.groups || (social.groups = {}));
        })(social = wix.social || (wix.social = {}));
        var reactions;
        (function (reactions) {
            var ReactionsService = /** @class */ (function () {
                function ReactionsService() {
                }
                return ReactionsService;
            }());
            reactions.ReactionsService = ReactionsService;
        })(reactions = wix.reactions || (wix.reactions = {}));
    })(wix = wrapper.wix || (wrapper.wix = {}));
    var com;
    (function (com) {
        var wix;
        (function (wix) {
            var core;
            (function (core) {
                var services;
                (function (services) {
                    var identification2;
                    (function (identification2) {
                        var PersonType;
                        (function (PersonType) {
                            PersonType["USER"] = "USER";
                            PersonType["SITEMEMBER"] = "SITEMEMBER";
                            PersonType["VISITOR"] = "VISITOR";
                        })(PersonType = identification2.PersonType || (identification2.PersonType = {}));
                        var IdentificationServiceV2 = /** @class */ (function () {
                            function IdentificationServiceV2() {
                            }
                            return IdentificationServiceV2;
                        }());
                        identification2.IdentificationServiceV2 = IdentificationServiceV2;
                    })(identification2 = services.identification2 || (services.identification2 = {}));
                })(services = core.services || (core.services = {}));
            })(core = wix.core || (wix.core = {}));
        })(wix = com.wix || (com.wix = {}));
        var wixpress;
        (function (wixpress) {
            var metasite;
            (function (metasite) {
                var reloose;
                (function (reloose) {
                    var api;
                    (function (api) {
                        var App;
                        (function (App) {
                            var State;
                            (function (State) {
                                State["UNKNOWN"] = "UNKNOWN";
                                State["ENABLED"] = "ENABLED";
                                State["DISABLED"] = "DISABLED";
                                State["TEMPLATE"] = "TEMPLATE";
                                State["PENDING"] = "PENDING";
                            })(State = App.State || (App.State = {}));
                        })(App = api.App || (api.App = {}));
                        var RelooseApi = /** @class */ (function () {
                            function RelooseApi() {
                            }
                            return RelooseApi;
                        }());
                        api.RelooseApi = RelooseApi;
                        var RelooseWarmupApi = /** @class */ (function () {
                            function RelooseWarmupApi() {
                            }
                            return RelooseWarmupApi;
                        }());
                        api.RelooseWarmupApi = RelooseWarmupApi;
                    })(api = reloose.api || (reloose.api = {}));
                })(reloose = metasite.reloose || (metasite.reloose = {}));
            })(metasite = wixpress.metasite || (wixpress.metasite = {}));
        })(wixpress = com.wixpress || (com.wixpress = {}));
    })(com = wrapper.com || (wrapper.com = {}));
})(wrapper = exports.wrapper || (exports.wrapper = {}));
//# sourceMappingURL=proto-generated.js.map